<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <ng-container *ngIf="tools">
            <app-tree [isMaterial]="false"
                      emptyMessage="{{'admin.lifts.batches.noToolsSelected' | translate}}"
                      [(items)]="treeDisplayTools"
            ></app-tree>
        </ng-container>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button *ngIf="areToolsSelected"
                    type="primary"
                    class="create"
                    [disabled]="isLoading"
                    (click)="removeToolsFromBatch()">
            {{ 'admin.lifts.batches.removeToolsFromBatch' | translate }}
        </app-button>
    </div>
</app-modal>
